import clsx from "clsx";

import { MouseEventHandler } from "react";
import styles from "./pagination.module.css";

export type PaginationProps = {
  type: "next" | "end" | null;
  data: {
    title: string;
    text: string;
    buttonLabel: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
  };
};

export const PaginationFallback = () => (
  <div className={styles.wrapper}>
    <h2>{"Det var slutten."}</h2>
    <p>
      {
        "... eller, det avhenger av om du foretrekker å starte Nedenfra og opp eller Ovenfra og ned ..."
      }
    </p>
    <button type="button" className={clsx(styles["scroll-button"], "outlined")}>
      {"Opp til toppen"}
    </button>
  </div>
);

const ClientPagination = ({ type, data, }: PaginationProps) => {
  const End = () =>
    type !== "end" ? null : (
      <>
        <h2>{data.title}</h2>
        <p>{data.text}</p>
        <button
          type="button"
          className={clsx(styles["scroll-button"], "outlined")}
          onClick={data.onClick}
        >
          {data.buttonLabel}
        </button>
      </>
    );

  const LoadMore = () =>
    type !== "next" ? null : (
      <>
        <>
          <h2>{data.title}</h2>
          <p>{data.text}</p>
          <button
            type="button"
            className={clsx(styles["scroll-button"], "outlined")}
            onClick={data.onClick}
          >
            {data.buttonLabel}
          </button>
        </>
      </>
    );

  return (
    <div className={styles.wrapper}>
      <End />
      <LoadMore />
    </div>
  );
};

export default ClientPagination;
